export interface IApplicationPermission {
    code: string;
    level: number;
    type: number;
}

export class ApplicationPermission implements IApplicationPermission {
    code: string;
    level: number;
    type: number;

    constructor();
    constructor(obj: IApplicationPermission);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.level = obj && obj.level || 0;
        this.type = obj && obj.type || 0;
    }
}

export class ApplicationPermissionSave {
    code: string;
    level: string;

    constructor();
    constructor(obj: IApplicationPermission);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.level = obj && obj.level || 0;
    }
}